import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 257.46 238.03"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M254.46,238.03c-1.66,0-3-1.34-3-3v-127.93h-48.28v127.93c0,1.66-1.34,3-3,3s-3-1.34-3-3V104.09c0-1.66,1.34-3,3-3h54.28c1.66,0,3,1.34,3,3v130.93c0,1.66-1.34,3-3,3Z" />
        <path d="M173.23,238.03c-1.66,0-3-1.34-3-3V6h-48.3v173.77c0,1.66-1.34,3-3,3s-3-1.34-3-3V3c0-1.66,1.34-3,3-3h54.3c1.66,0,3,1.34,3,3v232.03c0,1.66-1.34,3-3,3Z" />
        <path d="M37.71,101.32c-1.66,0-3-1.34-3-3v-33.77c0-1.66,1.34-3,3-3h54.27c1.66,0,3,1.34,3,3v32.94c0,1.66-1.34,3-3,3s-3-1.34-3-3v-29.94h-48.27v30.77c0,1.66-1.34,3-3,3Z" />
        <path d="M126.02,238.03c-1.66,0-3-1.34-3-3,0-35.77-36.66-41.11-58.51-41.11s-58.51,5.34-58.51,41.11c0,1.66-1.34,3-3,3s-3-1.34-3-3c0-29.94,23.51-47.11,64.51-47.11s64.51,17.17,64.51,47.11c0,1.66-1.34,3-3,3Z" />
        <path d="M64.51,174.14c-17.48,0-31.69-14.22-31.69-31.69s14.22-31.69,31.69-31.69,31.69,14.22,31.69,31.69-14.22,31.69-31.69,31.69ZM64.51,116.76c-14.17,0-25.69,11.53-25.69,25.69s11.53,25.69,25.69,25.69,25.69-11.53,25.69-25.69-11.53-25.69-25.69-25.69Z" />
      </g>
    </svg>
  )
}

export default Icon
